import { getSubdomain } from "../../context/ContextApp";
import { useDocumentTitle } from "../../hooks/document-title";
import { cataloguesAU, cataloguesCA, cataloguesNZ } from "./data";

const DigitalCataloguePage = () => {
  const appBranch = getSubdomain();
  useDocumentTitle("Digital Catalogue Downloads");

  const digitalCataloguePerBranch = {
    "nz": cataloguesNZ,
    "au": cataloguesAU,
    "ca": cataloguesCA,
    "": []
  }
  const digitalCatalogue = digitalCataloguePerBranch[appBranch]

  return (
    <div className="digital-catalogue-page">
      <h2>Digital Catalogue Links</h2>
      <section>
        {digitalCatalogue && digitalCatalogue.map((catalogue, index) => (
          <div key={index} className="digital-catalogue-category">
            <h3>{catalogue.title}</h3>
            {catalogue.items.map((catalogueItems, index2) => (
                <a className="digital-catalogue-download" key={index2} target="_blank" href={catalogueItems.link}>
                  {catalogueItems.altName}
                </a>
            ))
            }
          </div>
        ))
        }
      </section>
    </div>
  );
};

export default DigitalCataloguePage;
